import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59b7d9ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "revenu-info" }
const _hoisted_2 = { class: "revenu-title" }
const _hoisted_3 = { class: "big-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "revenu-title" }, null, -1))
const _hoisted_5 = { class: "revenu-info" }
const _hoisted_6 = { class: "revenu-title" }
const _hoisted_7 = { class: "big-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "revenu-title" }, null, -1))
const _hoisted_9 = { class: "revenu-info" }
const _hoisted_10 = { class: "revenu-title" }
const _hoisted_11 = { class: "big-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "revenu-title" }, null, -1))
const _hoisted_13 = { class: "revenu-info" }
const _hoisted_14 = { class: "revenu-title" }
const _hoisted_15 = { class: "big-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "revenu-title" }, null, -1))
const _hoisted_17 = { class: "calender-title" }
const _hoisted_18 = { class: "calender-sub-title" }
const _hoisted_19 = { class: "upcoming-container" }
const _hoisted_20 = {
  key: 0,
  class: "info-cal-title"
}
const _hoisted_21 = {
  key: 1,
  class: "info-cal-title"
}
const _hoisted_22 = { style: { width: '300px', border: '1px solid #d9d9d9', borderRadius: '4px' } }
const _hoisted_23 = { class: "title-card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  class: "rooms-donut",
  id: "roomsDonut"
}, null, -1))
const _hoisted_25 = { class: "flex-item-calender" }
const _hoisted_26 = { class: "calender-title" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("canvas", {
  id: "reservationStat",
  width: "150",
  height: "50"
}, null, -1))
const _hoisted_28 = { class: "flex-item-calender" }
const _hoisted_29 = { class: "calender-title" }
const _hoisted_30 = { class: "flex-item-calender" }
const _hoisted_31 = { class: "feed-desc" }
const _hoisted_32 = { class: "flex-item-calender" }
const _hoisted_33 = { class: "feed-title-container" }
const _hoisted_34 = { class: "item-title" }
const _hoisted_35 = { class: "feed-title" }
const _hoisted_36 = { class: "flex-item-calender" }
const _hoisted_37 = { class: "flex-item-calender" }
const _hoisted_38 = { class: "calender-title" }
const _hoisted_39 = {
  key: 0,
  class: "room-name-feed"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_ScheduleOutlined = _resolveComponent("ScheduleOutlined")!
  const _component_ApartmentOutlined = _resolveComponent("ApartmentOutlined")!
  const _component_FormOutlined = _resolveComponent("FormOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar_group = _resolveComponent("a-avatar-group")!
  const _component_a_calendar = _resolveComponent("a-calendar")!
  const _component_a_locale_provider = _resolveComponent("a-locale-provider")!
  const _component_a_rate = _resolveComponent("a-rate")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_progress = _resolveComponent("a-progress")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 12},
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.locale === 'ar' ? 'revenu-container-rtl' : 'revenu-container'])
                      }, [
                        _createVNode(_component_CalendarOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t('Meet.Meetings')), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_skeleton, {
                  loading: _ctx.loading,
                  size: _ctx.small,
                  active: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      align: "start",
                      vertical: "",
                      class: "numbers-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.state.meetingsNumber) + " " + _toDisplayString(_ctx.t('Meet.Meetings')), 1),
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "size"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 12},
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.locale === 'ar' ? 'order-container-rtl' : 'order-container'])
                      }, [
                        _createVNode(_component_ScheduleOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('Meet.ReservationRequests')), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_skeleton, {
                  loading: _ctx.loading,
                  size: _ctx.small,
                  active: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      align: "start",
                      vertical: "",
                      class: "numbers-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.state.reservationRequests) + " " + _toDisplayString(_ctx.t('Meet.Requests')), 1),
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "size"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 12},
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.locale === 'ar' ? 'products-container-rtl' : 'products-container'])
                      }, [
                        _createVNode(_component_ApartmentOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('Meet.ReservedRooms')), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_skeleton, {
                  loading: _ctx.loading,
                  size: _ctx.small,
                  active: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      align: "start",
                      vertical: "",
                      class: "numbers-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.state.reservedRooms) + " " + _toDisplayString(_ctx.t('Meet.Rooms')), 1),
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "size"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 12},
          lg: { span: 12 },
          xl: { span: 6 },
          xxl: { span: 6 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "middle",
                  justify: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.locale === 'ar' ? 'discount-container-rtl' : 'discount-container'])
                      }, [
                        _createVNode(_component_FormOutlined, { class: "revenu-icon" })
                      ], 2),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('Meet.InternalRequests')), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_skeleton, {
                  loading: _ctx.loading,
                  size: _ctx.small,
                  active: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_flex, {
                      align: "start",
                      vertical: "",
                      class: "numbers-container"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.state.internalRequests) + " " + _toDisplayString(_ctx.t('Meet.Requests')), 1),
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "size"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 24},
          lg: { span: 24 },
          xl: { span: 16 },
          xxl: { span: 16 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              hoverable: "",
              class: "calender-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  class: "flex-container",
                  gutter: 16
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 12},
                      lg: { span: 12 },
                      xl: { span: 12 },
                      xxl: { span: 12 },
                      class: "flex-item-icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CalendarOutlined, { class: "calender-icon" }),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('Meet.Meetings')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 12},
                      lg: { span: 12 },
                      xl: { span: 12 },
                      xxl: { span: 12 },
                      class: "flex-item-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          class: "event-btn",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigatePage('/meetings','2-1')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('Meet.CreateEvent')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 8},
                      lg: { span: 8 },
                      xl: { span: 8 },
                      xxl: { span: 8 },
                      class: "flex-item-calender"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.t('Meet.EventTitle')), 1),
                        _createVNode(_component_a_skeleton, {
                          loading: _ctx.loadingMeetings,
                          size: _ctx.small,
                          active: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.upcomingMeets, (item) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item,
                                class: "events-container-up"
                              }, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_a_badge, {
                                    color: _ctx.getTagColor(item.approved)
                                  }, null, 8, ["color"]),
                                  (item.motif)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(item.motif), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(item.room.name), 1))
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass([_ctx.locale === 'ar' ? 'info-cal-txt-rtl' : 'info-cal-txt'])
                                }, _toDisplayString(_ctx.formatEventDate(item.start,item.end)), 3),
                                _createVNode(_component_a_avatar_group, {
                                  "max-count": 2,
                                  "max-popover-trigger": "click",
                                  size: "small",
                                  "max-style": { color: _ctx.$primaryColor , backgroundColor: '#ffc1074d', cursor: 'pointer' },
                                  class: _normalizeClass([_ctx.locale === 'ar' ? 'info-cal-txt-rtl' : 'info-cal-txt'])
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.participants, (participant, index) => {
                                      return (_openBlock(), _createBlock(_component_a_tooltip, {
                                        key: index,
                                        title: `${participant.first_name} ${participant.last_name}`,
                                        placement: "top"
                                      }, {
                                        default: _withCtx(() => [
                                          (participant.photo !== null)
                                            ? (_openBlock(), _createBlock(_component_a_avatar, {
                                                key: 0,
                                                src: participant.photo
                                              }, null, 8, ["src"]))
                                            : (_openBlock(), _createBlock(_component_a_avatar, {
                                                key: 1,
                                                style: _normalizeStyle({backgroundColor: _ctx.$primaryColor })
                                              }, {
                                                icon: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.getFirstLetter(participant.first_name)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["style"]))
                                        ]),
                                        _: 2
                                      }, 1032, ["title"]))
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.external_participants, (external, index) => {
                                      return (_openBlock(), _createBlock(_component_a_tooltip, {
                                        key: index,
                                        title: `${external.email}`,
                                        placement: "top"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_avatar, null, {
                                            icon: _withCtx(() => [
                                              _createVNode(_component_UserOutlined)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["title"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["max-style", "class"])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["loading", "size"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 16},
                      lg: { span: 16 },
                      xl: { span: 16 },
                      xxl: { span: 16 },
                      class: "flex-item-btn"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_locale_provider, { locale: _ctx.calendarLocale }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_calendar, {
                                value: _ctx.calendarDash,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.calendarDash) = $event)),
                                fullscreen: false,
                                onChange: _ctx.handleDashCalendar
                              }, null, 8, ["value", "onChange"])
                            ]),
                            _: 1
                          }, 8, ["locale"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 24},
          lg: { span: 24 },
          xl: { span: 8 },
          xxl: { span: 8 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              hoverable: "",
              class: "donut-card"
            }, {
              title: _withCtx(() => [
                _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.t('Meet.RoomOccupancy')), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 24},
          lg: { span: 24 },
          xl: { span: 24 },
          xxl: { span: 24 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.t('Meet.MonthlyResrvationStat')), 1)
                ]),
                _hoisted_27
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 24},
          lg: { span: 12 },
          xl: { span: 12 },
          xxl: { span: 12 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.t('Meet.RecentReviews')), 1)
                ]),
                _createVNode(_component_a_list, {
                  class: "demo-loadmore-list",
                  loading: _ctx.initLoading,
                  "item-layout": "horizontal",
                  "data-source": _ctx.state.recentFeedbacks
                }, {
                  renderItem: _withCtx(({ item }) => [
                    _createVNode(_component_a_list_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_skeleton, {
                          avatar: "",
                          title: false,
                          loading: !!item.loading,
                          active: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_list_item_meta, { class: "feed-item" }, {
                              description: _withCtx(() => [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("p", _hoisted_31, _toDisplayString(item.note), 1)
                                ])
                              ]),
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_a_rate, {
                                      value: item.rate,
                                      "allow-half": "",
                                      disabled: ""
                                    }, null, 8, ["value"])
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("p", _hoisted_35, _toDisplayString(item.user.first_name) + " " + _toDisplayString(item.user.last_name), 1),
                                    _createElementVNode("p", {
                                      class: _normalizeClass([_ctx.locale === 'ar' ? 'date-feed-txt-rtl' : 'date-feed-txt'])
                                    }, _toDisplayString(_ctx.formatDisplayDate(item.created_at)), 3)
                                  ])
                                ])
                              ]),
                              avatar: _withCtx(() => [
                                (item.user.photo!==null)
                                  ? (_openBlock(), _createBlock(_component_a_avatar, {
                                      key: 0,
                                      src: item.user.photo
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true),
                                (item.user.photo===null)
                                  ? (_openBlock(), _createBlock(_component_a_avatar, { key: 1 }, {
                                      icon: _withCtx(() => [
                                        _createVNode(_component_UserOutlined)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["loading"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["loading", "data-source"]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("p", {
                    class: "more-action",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigatePage('/feedback', '7')))
                  }, _toDisplayString(_ctx.t('Meet.AllRating&Reviews')) + " >> ", 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: { span: 24},
          sm: { span: 24},
          md: {span: 24},
          lg: { span: 12 },
          xl: { span: 12 },
          xxl: { span: 12 },
          class: "card-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, { hoverable: "" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.t('Meet.RatingDistribution')), 1)
                ]),
                _createVNode(_component_a_row, { gutter: 16 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 24},
                      lg: { span: 24 },
                      xl: { span: 8 },
                      xxl: { span: 8 },
                      class: "prog-container"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_progress, {
                          type: "circle",
                          "stroke-color": {
                                '0%': '#ff6384',
                                '100%': '#ff9f40',
                            },
                          percent: _ctx.state.nbFeeds,
                          format: percent => `${percent}`,
                          size: 160
                        }, null, 8, ["percent", "format"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, {
                      xs: { span: 24},
                      sm: { span: 24},
                      md: {span: 24},
                      lg: { span: 24 },
                      xl: { span: 16 },
                      xxl: { span: 16 }
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.feedbackRates, (item) => {
                          return (_openBlock(), _createBlock(_component_a_row, {
                            key: item,
                            class: "feed-back-room-container"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                span: 6,
                                class: "room-name-container"
                              }, {
                                default: _withCtx(() => [
                                  (item.feedbackable !== null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(item.feedbackable.name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 18 }, {
                                default: _withCtx(() => [
                                  (item.feedbackable !== null)
                                    ? (_openBlock(), _createBlock(_component_a_progress, {
                                        key: 0,
                                        percent: item.percent_of_feedback,
                                        "stroke-color": item.feedbackable.color ? item.feedbackable.color : 'indigo'
                                      }, null, 8, ["percent", "stroke-color"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}